import { render, staticRenderFns } from "./ClamRepayRadio3.vue?vue&type=template&id=8fbba866&"
import script from "./ClamRepayRadio3.vue?vue&type=script&lang=js&"
export * from "./ClamRepayRadio3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports